export const isContactForm = (form) => {
  if (!form) return false;
  const relatedObject = form.relatedObject || form.related_object;
  return relatedObject?.name === 'client_client';
};
